import React from "react";
import { Routes, Route } from "react-router-dom";
import PfpGeneratorPage from "./pages/PfpGeneratorPage";
import GlobalStyles from "./styles/GlobalStyles";
import { ThemeProvider } from "styled-components";
import { light } from "./styles/Themes";
import { usePerformanceMonitor } from "./components/PerformanceMonitor";
import Navigation from "./components/Navigation";
import About from "./components/sections/About";
import Home from "./components/sections/Home";
import Team from "./components/sections/Team";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import { usePageTracking } from './hooks/usePageTracking';

function App() {
  // 启用性能监控 (仅在开发模式)
  usePerformanceMonitor();

  // 使用页面追踪
  usePageTracking();

  return (
    <>
      <GlobalStyles />
      <ThemeProvider theme={light}>
        <Routes>
          <Route path="/pfp-generator" element={<PfpGeneratorPage />} />
          <Route
            path="/"
            element={
              <>
                <Navigation />
                <Home />
                <About />
                <Team />
                <Footer />
                <ScrollToTop />
              </>
            }
          />
        </Routes>
      </ThemeProvider>
    </>
  );
}

export default App;
